export { TheatricalFooter } from './TheatricalFooter'
export type { TheatricalFooterProps } from './TheatricalFooter'
